export default __webpack_public_path__ + "static/media/default.e1f305db.jpg";